/**
 * Labstep
 *
 * @module components/Layout/Links/Mobile
 * @desc Rendering links only on mobile
 */

import { LayoutLinks } from 'labstep-web/components/Layout/Links';
import { MediaQueryDesktop as Desktop } from 'labstep-web/core/MediaQuery/Desktop';
import { Switch } from 'labstep-web/core/Switch';
import type React from 'react';
import type { LayoutLinksMobileProps } from './types';

export const LayoutLinksMobile: React.FC<LayoutLinksMobileProps> = ({
  links,
  screens,
}) => {
  const linksWithRender = links.map((route, i) => ({
    ...route,
    render: screens[i],
  }));

  return (
    <Desktop>
      {({ match }) =>
        !match ? (
          <LayoutLinks links={linksWithRender} noBottomMargin />
        ) : (
          <Switch links={linksWithRender} />
        )
      }
    </Desktop>
  );
};
